import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { Checkbox } from "@mui/material";
import "../../../../style/forms.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  errors: any;
  control: any;
  setValue: any;
}

const RegulaminListCheckboxes: React.FC<IProps> = ({ errors, control, setValue }) => {
  const { t } = useTranslation();
  const regulaminList = useSelector((state: State) => state.config.configuration.regulaminList);
  const [acceptedItems, setAcceptedItems] = useState<string[]>([]);
  const [error, setError] = useState(false);

  const handleChange = (name: string) => {
    if (acceptedItems.includes(name)) {
      const newAcceptedItemsArr = [...acceptedItems.filter((item) => item !== name)];
      setAcceptedItems(newAcceptedItemsArr);
    } else {
      const newAcceptedItemsArr = [...acceptedItems];
      newAcceptedItemsArr.push(name);
      setAcceptedItems(newAcceptedItemsArr);
    }
  };

  useEffect(() => {
    control.register("acceptStatute", { required: true });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (acceptedItems && regulaminList && acceptedItems.length === regulaminList.length) {
      setValue("acceptStatute", true);
    } else {
      setValue("acceptStatute", false);
    }
    //eslint-disable-next-line
  }, [acceptedItems, regulaminList]);

  useEffect(() => {
    if (errors.acceptStatute) {
      setError(true);
    } else {
      setError(false);
    }
  }, [errors, acceptedItems]);

  return (
    <div style={{ width: "100%" }}>
      {regulaminList && 
<>
      {regulaminList.map((item) => (
        <div className="checkboxInput" id={`checkbox-${item.name}`}>
          <div className="one-checkbox">
            <Checkbox
              checked={acceptedItems.includes(item.name)}
              onChange={() => handleChange(item.name)}
              name={item.name}
              className="checkbox-input"
            />
            <span>
              {" "}
              <a target="_blank" href={item.file} rel="noreferrer">
                *{item.name}
              </a>
            </span>
          </div>
          {error && !acceptedItems.includes(item.name) && (
            <div style={{ margin: "auto", width: "80%" }} className="alert alert-red">
              *{t("to_pole_jest_wymagane")}
            </div>
          )}
        </div>
      ))}
</>}
    </div>
  );
};

export default RegulaminListCheckboxes;
